export enum ChooseAccountLocalizationId {
    StepTitle = "sign-in-choose-account.step_title",
    ContinueButton = "sign-in-choose-account.continue_button",
    StepPicture = "sign-in-choose-account.step_picture",
}
